export const baseUrl = process.env.BASE_URL || "/";
export enum CALCULATOR_TYPES {
  ANTIPYRETIC_SYRUP,
  CHILD_HEIGHT,
  GIRLS_CYCLE,
  SUPPOSITORY,
}
export const checkoutUrl = `/zamowienie/`;
export const calculatorsUrl = "/kalkulatory";
export const sensitiveQuestionsUrl = "/trudne-pytania/";
export const askSensitiveQuestionUrl = "/trudne-pytania/zadaj-pytanie";
export const generateCalculatorUrl = (type: CALCULATOR_TYPES) => {
  switch (type) {
    case CALCULATOR_TYPES.ANTIPYRETIC_SYRUP:
      return `${calculatorsUrl}/objetosc-syropu-przeciwgoraczkowego`;
    case CALCULATOR_TYPES.CHILD_HEIGHT:
      return `${calculatorsUrl}/przewidywany-wzrost-dziecka`;
    case CALCULATOR_TYPES.GIRLS_CYCLE:
      return `${calculatorsUrl}/cykl-dla-dziewczynek`;
    case CALCULATOR_TYPES.SUPPOSITORY:
      return `${calculatorsUrl}/czopki`;
    default:
      return calculatorsUrl;
  }
};
export const blogUrl = baseUrl;
export const generateBlogCategoryUrl = (slug: string, parentSlug?: string) => `${blogUrl}${parentSlug ? `${parentSlug}/` : ''}${slug}/`;
export const generateBlogTagUrl = (slug: string, parentSlug?: string) => `${blogUrl}tag/${parentSlug ? `${parentSlug}/` : ''}${slug}/`;
export const generateSensitiveQuestionsCategoryUrl = (slug: string) =>
  `${sensitiveQuestionsUrl}${slug}/`;
export const previewArticleUrl = `${baseUrl}preview/article/`;
export const previewArticleDetailsUrl = `${baseUrl}preview/article/:slug`;
